import { render, staticRenderFns } from "./StepFluLetter.vue?vue&type=template&id=4ca4857c&"
import script from "./StepFluLetter.vue?vue&type=script&lang=js&"
export * from "./StepFluLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports